var __TEMP__ = require('./_Symbol.js');var Symbol = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_copyArray.js');var copyArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getTag.js');var getTag = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArrayLike.js');var isArrayLike = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isString.js');var isString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_iteratorToArray.js');var iteratorToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_mapToArray.js');var mapToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToArray.js');var setToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringToArray.js');var stringToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./values.js');var values = __REQUIRE_DEFAULT__(__TEMP__);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = toArray;
